import Preloader from '../Preloader';
const AbstractsWebPart = (body) => {
    
    const $ = window.$ || window.jQuery;
    //var NamsResultsObj = {}
    const Abstractscontainer = document.querySelector('#ResultsSection');
	if (!Abstractscontainer) {
        return;
    }


// New script start as excel sheet start 09/16/2020

var NamsResultsObj = {
    "AbstractData": [
        {
            "Category": "Speaker Presentation",
            "Session Title": "Menopause 101 Course: Building the Foundation",
            "Lecture Title": "Menopause 101: How to Initiate Treatment",
            "Speaker": "Risa Kagan, MD; FACOG, CCD, NCMP",
            "Location": "Berkeley, CA",
            "Name of PDF File": "Kagan101.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Menopause 101 Course: Building the Foundation",
            "Lecture Title": "Menopause 101: Dose, Route, and Formulation",
            "Speaker": "Gloria A. Richard-Davis, MD, MBA, NCMP, FACOG",
            "Location": "Little Rock, AR",
            "Name of PDF File": "RichardDavis101.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Menopause 101 Course: Building the Foundation",
            "Lecture Title": "Hormone Contraception in Older Reproductive Women and Transition to Hormone Therapy",
            "Speaker": "Andrew M. Kaunitz, MD, FACOG, NCMP",
            "Location": "Jacksonville, FL",
            "Name of PDF File": "Kaunitz101.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Menopause 101 Course: Building the Foundation",
            "Lecture Title": "Maintaining Wellness in Perimenopause and Beyond",
            "Speaker": "Heather D. Hirsch, MD, MS, NCMP",
            "Location": "Boston, MA",
            "Name of PDF File": "Hirsch101.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Menopause 101 Course: Building the Foundation",
            "Lecture Title": "Nonhormone Management of Hot Flashes",
            "Speaker": "Catherine Hansen, MD, FRCSC, FACOG, MPH, NCMP",
            "Location": "Houston, TX",
            "Name of PDF File": "Hansen101.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Menopause 101 Course: Building the Foundation",
            "Lecture Title": "Sexual Health: Libido and Testosterone",
            "Speaker": "Brooke M. Faught, DNP, WHNP-BC, NCMP, IF",
            "Location": "Nashville, TN",
            "Name of PDF File": "Faught101.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Pre-Meeting Symposium: Menopause Symptom Management in 2020: One Size Doesn't Fit All",
            "Lecture Title": "The Burden of Menopause on Vasomotor Symptoms and Genitourinary Syndrome of Menopause",
            "Speaker": "Wen Shen, MD, MPH",
            "Location": "Baltimore, MD",
            "Name of PDF File": "ShenPre.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Pre-Meeting Symposium: Menopause Symptom Management in 2020: One Size Doesn't Fit All",
            "Lecture Title": "Hormone Therapy in 2020",
            "Speaker": "Jan L. Shifren, MD, NCMP",
            "Location": "Boston, MA",
            "Name of PDF File": "ShifrenPre.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Pre-Meeting Symposium: Menopause Symptom Management in 2020: One Size Doesn't Fit All",
            "Lecture Title": "Nonpharmacologic Therapies for Vasomotor Symptoms",
            "Speaker": "Janet S. Carpenter, PhD, RN, FAAN",
            "Location": "Indianapolis, IN",
            "Name of PDF File": "CarpenterPre.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Pre-Meeting Symposium: Menopause Symptom Management in 2020: One Size Doesn't Fit All",
            "Lecture Title": "Recent Advances in the Treatment of Vasomotor Symptoms: Nonhormonal Therapies",
            "Speaker": "Susan D. Reed, MD, MPH, MS",
            "Location": "Seattle, WA",
            "Name of PDF File": "ReedPre.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Pre-Meeting Symposium: Menopause Symptom Management in 2020: One Size Doesn't Fit All",
            "Lecture Title": "New Hormone Therapies for Vasomotor Symptoms",
            "Speaker": "Hugh S. Taylor, MD",
            "Location": "New Haven, CT",
            "Name of PDF File": "TaylorPre.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Pre-Meeting Symposium: Menopause Symptom Management in 2020: One Size Doesn't Fit All",
            "Lecture Title": "Compounded Bioidentical Hormone Therapy",
            "Speaker": "Cynthia A. Stuenkel, MD, NCMP",
            "Location": "La Jolla, CA",
            "Name of PDF File": "StuenkelPre.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Pre-Meeting Symposium: Menopause Symptom Management in 2020: One Size Doesn't Fit All",
            "Lecture Title": "Management of Symptoms in Perimenopause",
            "Speaker": "Pelin Batur, MD, FACP, NCMP, CCD",
            "Location": "Cleveland, OH",
            "Name of PDF File": "BaturPre.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Pre-Meeting Symposium: Menopause Symptom Management in 2020: One Size Doesn't Fit All",
            "Lecture Title": "Genitourinary Syndrome of Menopause Management",
            "Speaker": "Amanda L. Clark, MD, MCR, NCMP",
            "Location": "Portland, OR",
            "Name of PDF File": "ClarkPre.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 1 - Novel Risk Factors for Cardiovascular Disease in Women",
            "Lecture Title": "Human Social Genomics: Implications for Cardiovascular Disease in Women",
            "Speaker": "Steven W. Cole, PhD",
            "Location": "Los Angeles, CA",
            "Name of PDF File": "Cole1.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 1 - Novel Risk Factors for Cardiovascular Disease in Women",
            "Lecture Title": "Novel Phenotypes of Cardiovascular Disease in Women",
            "Speaker": "C. Noel Bairey Merz, MD, FACCD",
            "Location": "Los Angeles, CA",
            "Name of PDF File": "BaireyMerz1.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 1 - Novel Risk Factors for Cardiovascular Disease in Women",
            "Lecture Title": "Women's Cardiovascular Health at Midlife: The Role of Hot Flashes, Sleep Problems, and Trauma",
            "Speaker": "Rebecca C. Thurston, PhD",
            "Location": "Pittsburgh, PA",
            "Name of PDF File": "Thurston1.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 2 - Hormones of Menopause",
            "Lecture Title": "Is FSH An Active Driver of Menopause?",
            "Speaker": "T. Rajendra Kumar, PhD",
            "Location": "Aurora, CO",
            "Name of PDF File": "Kumar2.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 2 - Hormones of Menopause",
            "Lecture Title": "Estradiol and Estrone: Changing Ratios After Menopause",
            "Speaker": "Richard J. Auchus, MD, PhD",
            "Location": "Ann Arbor, MI ",
            "Name of PDF File": "Auchus2.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 3 - Weight, Weight, Don't Tell Me",
            "Lecture Title": "Body Composition and Fat Patterning: The Role of Age and Estrogen",
            "Speaker": "Wendy M. Kohrt, PhD",
            "Location": "Aurora, CO",
            "Name of PDF File": "Kohrt3.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 3 - Weight, Weight, Don't Tell Me",
            "Lecture Title": "Medical and Surgical Management of Weight Loss",
            "Speaker": "Daniel H. Bessesen, MD",
            "Location": "Aurora, CO",
            "Name of PDF File": "Bessesen3.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 4 - Sleep and Anxiety: Sleep Perchance to Dream",
            "Lecture Title": "Sleep, Appetite Regulation, and Weight Gain",
            "Speaker": "Kelly Glazer Baron, PhD, MPH, DBSM",
            "Location": "Salt Lake City, UT",
            "Name of PDF File": "Baron4.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 4 - Sleep and Anxiety: Sleep Perchance to Dream",
            "Lecture Title": "Women, Anxiety, and Menopause: Novel Treatments for Anxiety Disorders",
            "Speaker": "Andrew M. Novick, MD, PhD",
            "Location": "Aurora, CO",
            "Name of PDF File": "Novick4.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 5 - Cognition and Menopause: Putting Your Best Brain Forward",
            "Lecture Title": "How to KEEP Sharp: The KEEPS Cognition Follow-Up",
            "Speaker": "Kejal Kantarci, MD, MS",
            "Location": "Rochester, MN",
            "Name of PDF File": "Kantarci5.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 6 - Caution to Menopause Practitioners Addressing Sexual Health Concerns: Look Both Ways!",
            "Lecture Title": "Caution to Menopause Practitioners Addressing Sexual Health Concerns: Look Both Ways!",
            "Speaker": "Sheryl A. Kingsberg, PhD; Stanley E. Althof, PhD",
            "Location": "Cleveland, OH; Greenacres, FL",
            "Name of PDF File": "KingsbergAlthof6.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 7 - Special Needs of Women When Menopause Comes Early: Primary Ovarian Insufficiency and Contraception",
            "Lecture Title": "Surgical Menopause and Primary Ovarian Insufficiency",
            "Speaker": "Wendy Wolfman, MD, FRCSC, FACOG",
            "Location": "Toronto, Ontario, Canada",
            "Name of PDF File": "Wolfman7.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 7 - Special Needs of Women When Menopause Comes Early: Primary Ovarian Insufficiency and Contraception",
            "Lecture Title": "Contraception",
            "Speaker": "Jeffrey T. Jensen, MD, MPH",
            "Location": "Portland, OR",
            "Name of PDF File": "Jensen7.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 8 - New Guidelines and How to Apply Them",
            "Lecture Title": "NAMS Genitourinary Syndrome of Menopause Position Statement",
            "Speaker": "Stephanie S. Faubion, MD, MBA, FACP, NCMP, IF",
            "Location": "Jacksonville, FL",
            "Name of PDF File": "Faubion8.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 8 - New Guidelines and How to Apply Them",
            "Lecture Title": "NAMS 2021 Osteoporosis Position Statement",
            "Speaker": "Michael R. McClung, MD, FACP, FASBMR, FACE",
            "Location": "Portland, OR",
            "Name of PDF File": "McClung8.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 9 - Cardiovascular Disease and Women",
            "Lecture Title": "Heart Fat and Menopause",
            "Speaker": "Samar R. El Khoudary, PhD, MPH, BPharm, FAHA",
            "Location": "Pittsburgh, PA",
            "Name of PDF File": "ElKhoudary9.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 9 - Cardiovascular Disease and Women",
            "Lecture Title": "Heart Disease: Distinctions in Women",
            "Speaker": "Judith Regensteiner, PhD",
            "Location": "Aurora, CO",
            "Name of PDF File": "Regensteiner9.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Special Lectures",
            "Session Title": "Keynote Address",
            "Lecture Title": "What Is Wellness?",
            "Speaker": "James O. Hill, PhD",
            "Location": "Birmingham, AL",
            "Name of PDF File": "Hill.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Special Lectures",
            "Session Title": "NAMS/Kenneth W. Kleinman Endowed Lecture",
            "Lecture Title": "Social Media and Menopause: Separating Health From Hype and Why It Matters",
            "Speaker": "Jen Gunter MD, FRCS(C), FACOG, DABPM, ABPMR ",
            "Location": "San Francisco, CA",
            "Name of PDF File": "Gunter.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Special Lectures",
            "Session Title": "NAMS/Pfizer Wulf H. Utian Endowed Lecture",
            "Lecture Title": "Ghosts From the Past: Impact of Childhood Adversity on Mood and Cognition at Menopause",
            "Speaker": "C. Neill Epperson, MD",
            "Location": "Aurora, CO",
            "Name of PDF File": "Epperson.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/speakers/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Evaluation of a Discussion Guide to Promote Understanding of Menopause and Informed Decision Making",
            "Speaker": "Emma Andrews, PharmD",
            "Location": "New York City, NY",
            "Name of PDF File": "S-1.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Reproductive period duration and cognitive function in postmenopausal Hispanic/Latina women in the HCHS/SOL",
            "Speaker": "Yamnia Ivelisse Cortés, PhD, MPH, FNP-BC",
            "Location": "Chapel Hill, NC",
            "Name of PDF File": "S-2.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "HDL composition and function in relation with calcium density of coronary artery plaque among women transitioning through menopause. The SWAN HDL ancillary study",
            "Speaker": "Samar R. El Khoudary, PhD, MPH, BPharm, FAHA",
            "Location": "Pittsburgh, PA",
            "Name of PDF File": "S-3.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Cholesterol efflux capacity of HDL particles over the menopause transition: The SWAN HDL ancillary study",
            "Speaker": "Samar R. El Khoudary, PhD, MPH, BPharm, FAHA",
            "Location": "Pittsburgh, PA",
            "Name of PDF File": "S-4.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Fractional CO2 Laser Therapy, a Promising Treatment Alternative for Vulvovaginal Symptoms in Menopause, Breast Cancer and Lichen Sclerosus",
            "Speaker": "Alyssa Gardner, MD",
            "Location": "Waunakee, WI",
            "Name of PDF File": "S-5.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Waist to hip ratio predicts cognitive trajectory regardless of hormone therapy use: Analysis from Kronos Early Estrogen Prevention Study’s Cognitive and Mood Ancillary Study (KEEPS-Cog)",
            "Speaker": "Carey E. Gleason, PhD",
            "Location": "Madison, WI",
            "Name of PDF File": "S-6.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Postmenopausal Dyspareunia – Where Does It Hurt?",
            "Speaker": "Martha F Goetsch, MD, MPH",
            "Location": "Portland, OR",
            "Name of PDF File": "S-7.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "A novel, non-hormonal, non-invasive ultrasound device is effective in treating the symptoms of vaginal dryness associated with genitourinary syndrome of menopause (GSM)",
            "Speaker": "Martha Hickey, MD",
            "Location": "Melbourne, Victoria, Australia",
            "Name of PDF File": "S-8.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "NT-814, a Non-hormonal Dual NK1,3 Receptor Antagonist Markedly Improves Sleep, Mood and Quality of Life in Post-Menopausal Women; Results of a Randomised, Double-Blind, Placebo-Controlled Study (SWITCH-1)",
            "Speaker": "Hadine Joffe, MD, MSc",
            "Location": "Boston, MA",
            "Name of PDF File": "S-9.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Effect of Vasomotor Symptom Frequency and Comorbidities on Sleep Quality Among Women in Midlife: a Retrospective Analysis of the US SWAN Database",
            "Speaker": "Risa Kagan, MD, FACOG, CCD, NCMP",
            "Location": "Berkeley, CA",
            "Name of PDF File": "S-10.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Higher blood pressure is associated with loss of white matter integrity and higher Alzheimer’s tau biomarkers in postmenopausal women of the KEEPS Continuation Study",
            "Speaker": "Firat Kara, PhD",
            "Location": "Rochester, MN",
            "Name of PDF File": "S-11.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Effect of estradiol therapy on markers of inflammation: Results from the Early vs Late Intervention Trial with Estradiol (ELITE)",
            "Speaker": "Roksana Karim, PhD, MBBS",
            "Location": "La Crescenta, CA",
            "Name of PDF File": "S-12.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "A clinical study to evaluate Elismetrep (TRPM8 antagonist), a non-hormonal drug for the treatment of vasomotor symptoms in postmenopausal women",
            "Speaker": "Sheryl Kingsberg, PhD",
            "Location": "Cleveland, OH",
            "Name of PDF File": "S-13.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Anti-Müllerian hormone (AMH) and markers of oxidative stress, inflammation, and endothelial dysfunction",
            "Speaker": "Melissa F. Wellons , MD, MHS",
            "Location": "Nashville, TN",
            "Name of PDF File": "S-14.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Global Prospective Survey of Women with Vasomotor Symptoms Associated with Menopause: US Findings",
            "Speaker": "Robin Kroll, MD, NCMP",
            "Location": "Seattle, WA",
            "Name of PDF File": "S-15.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Real-life impact of menopause on midlife women’s health and well-being: A comprehensive survey of U.S. women’s health choices, behaviors and experiences during various stages of menopause.",
            "Speaker": "Monica P Mallampalli, PhD",
            "Location": "Red Bank, NJ",
            "Name of PDF File": "S-16.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Associations of abdominal and intrathoracic fat depots with high-density lipoprotein metrics in midlife women: The SWAN Study",
            "Speaker": "Alexis Nasr, MD",
            "Location": "Pittsburgh, PA",
            "Name of PDF File": "S-17.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "The Severity of Vasomotor Symptoms and Number of Menopausal Symptoms in Postmenopausal Women and Select Clinical Health Outcomes in the Women’s Health Initiative Calcium and Vitamin D Randomized Clinical Trial",
            "Speaker": "Matthew Stephen  Nudy, MD",
            "Location": "Hummelstown, PA",
            "Name of PDF File": "S-18.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Female Sexual Function and Urinary Incontinence: Six Month Follow-up after High-Intensity Focused Electromagnetic Procedure",
            "Speaker": "Julene B. Samuels, MD, FACS",
            "Location": "Prospect, KY",
            "Name of PDF File": "S-19.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Bioenergetic Markers and Cognition in Peri- and Postmenopausal Women",
            "Speaker": "Rachel A Schroeder, BS",
            "Location": "Chicago, IL",
            "Name of PDF File": "S-20.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "NT-814, a Non-Hormonal Dual Neurokinin 1,3 Receptor Antagonist Markedly Improves Hot Flashes in Post-Menopausal Women; Results of a Randomised, Double-Blind, Placebo-Controlled Study",
            "Speaker": "James Simon, MD, CCD, NCMP, IF, FACOG",
            "Location": "WA, DC",
            "Name of PDF File": "S-21.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Effect of hormone therapy on lipoprotein subfractions in early and late postmenopausal women",
            "Speaker": "Intira Sriprasert, MD",
            "Location": "Alhambra, CA",
            "Name of PDF File": "S-22.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "How important is sex to women during midlife?",
            "Speaker": "Holly Nicole Thomas, MD, MS",
            "Location": "Pittsburgh, PA",
            "Name of PDF File": "S-23.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/orals/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "The Effect of Early Menopause on the Development of Osteoporosis in the Canadian Longitudinal Study on Aging.",
            "Speaker": "Alice Buwembo, MD, MSc",
            "Location": "Hamilton, ON",
            "Name of PDF File": "P-1.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "A MsFLASH Investigation of Self-reported Menopausal Palpitations Distress",
            "Speaker": "Janet S. Carpenter, PhD, RN, FAAN",
            "Location": "Indianapolis, IN",
            "Name of PDF File": "P-2.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "The effect of menopause on metabolic syndrome: Cross-sectional results from the Canadian Longitudinal Study on Aging",
            "Speaker": "Marie Katherine Christakis, MD, MPH",
            "Location": "East  York, ON",
            "Name of PDF File": "P-3.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Resident Physician Impressions of Menopause Core Content Delivered by Podcast",
            "Speaker": "Amanda Clark, MD, MCR, NCMP",
            "Location": "Portland, OR",
            "Name of PDF File": "P-4.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "A Novel Consumer Based Product for Vasomotor Symptoms (VMS) of Menopause; Prototype Trial.",
            "Speaker": "Alyssa Dweck, MS, MD, FACOG",
            "Location": "Scarsdale, NY",
            "Name of PDF File": "P-5.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Qualitative Study of the Burden of Vasomotor Symptoms Associated With Menopause and Content Validity of Two PROMIS Sleep Measures in Menopausal Women",
            "Speaker": "Marci English, MPH",
            "Location": "Northbrook, IL",
            "Name of PDF File": "P-6.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Perception of Menopause in South America",
            "Speaker": "Vivian L Ernst - Baez, MD",
            "Location": "Basking Ridge, NJ",
            "Name of PDF File": "P-7.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Examining the Long-Term Brain Effects of Menopausal Hormone Therapy: KEEPS Continuation Study",
            "Speaker": "Carola Ferrer Simó, MPH",
            "Location": "Madison, WI",
            "Name of PDF File": "P-8.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Dyspareunia and the resulting impairment of daily life improves over time in equal measure when using a hormone-free moisturizing vaginal cream or a standard estriol cream",
            "Speaker": "Susana Garcia de Arriba, MD",
            "Location": "Bielefeld, Germany",
            "Name of PDF File": "P-9.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "  Cannabis use for menopause symptom management among midlife women Veterans",
            "Speaker": "Carolyn Gibson, PhD, MPH",
            "Location": "San Francisco, CA",
            "Name of PDF File": "P-10.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "The Effects of a 17β-estradiol, Softgel, Vaginal Insert on Vulvar and Vaginal Atrophy (VVA), Including Moderate to Severe Dyspareunia and Vaginal Dryness in Postmenopausal Women > 60 Years of Age",
            "Speaker": "Steven R Goldstein, MD, FACOG, CCD, NCMP",
            "Location": "New York, NY",
            "Name of PDF File": "P-11.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "SJX-653 Demonstrates Potent NK3 Antagonism Across Nonclinical and Clinical Studies",
            "Speaker": "Philip Graham, PhD",
            "Location": "Boston, MA",
            "Name of PDF File": "P-12.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Metabolic Risk Factors and Cognitive Function in Midlife Women from Sub-Saharan Africa",
            "Speaker": "Nicole Gusti Jaff, PhD, NCMP",
            "Location": "Johannesburg, South Africa",
            "Name of PDF File": "P-13.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Trauma and Sleep Problems Over Midlife in Women",
            "Speaker": "Karen P Jakubowski, PhD",
            "Location": "Pittsburgh, PA",
            "Name of PDF File": "P-14.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Lifetime History of Intimate Partner Violence and Current Clinical Insomnia Among Midlife Women Veterans",
            "Speaker": "Karen P Jakubowski, PhD",
            "Location": "Pittsburgh, PA",
            "Name of PDF File": "P-15.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Implementation of Standardized Practice Guideline May Allow Stabilization of Serum Hormone Levels and Impact the Incidence of Side Effects in Women Taking Custom-Compounded Hormone Therapy",
            "Speaker": "Xuezhi Jiang, MD, PhD",
            "Location": "Reading, PA",
            "Name of PDF File": "P-16.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Fezolinetant Attenuates Hot Flash-like Symptoms via Inhibition of Neuronal Activity in the Median Preoptic Nucleus in Ovariectomized Rats",
            "Speaker": "Seiji Kaku",
            "Location": "Tsukuba, Ibaraki, Japan",
            "Name of PDF File": "P-17.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Postchemotherapy serum FSH as a predictor of ovarian function recovery in young cancer patients",
            "Speaker": "Hye Kyeong Kim, PhD",
            "Location": "Seoul, South Korea",
            "Name of PDF File": "P-18.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "KAP (knowledge, attitude and practice) survey on THM in the Santiago (Chile) population.",
            "Speaker": "Pablo A Lavín, MD, MPH, MSc",
            "Location": "Santiago, Chile",
            "Name of PDF File": "P-19.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Nutrient Gaps for Women of Menopausal Transition Age in the United States",
            "Speaker": "LeeCole Legette, PhD",
            "Location": "West Hills, CA",
            "Name of PDF File": "P-20.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Differences in patient-reported rates of hormone therapy use by provider specialty",
            "Speaker": "Megan McCarty, MD",
            "Location": "Pittsburgh, PA",
            "Name of PDF File": "P-21.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Pelvic Floor Clinic model; collaborative and convenient delivery provides improvement in pelvic floor symptoms, mood, and quality of life.",
            "Speaker": "Jean Marie Frances McGowan, MD, NCMP",
            "Location": "Fargo, ND",
            "Name of PDF File": "P-22.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Adverse Childhood Experiences and Menopause Stage Impact Mood, Cognition, and Basal Inflammatory Markers",
            "Speaker": "Christina Metcalf, MA",
            "Location": "Aurora, CO",
            "Name of PDF File": "P-24.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "A survey of healthcare provider knowledge, attitudes, and preferences in management of Genitourinary Syndrome of Menopause (GSM) in the Mid-South",
            "Speaker": "Joshua Morris, MD, MA",
            "Location": "Memphis, TN",
            "Name of PDF File": "P-25.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Patient Satisfaction With the Use of Revaree to Treat Vaginal Atrophy Symptoms",
            "Speaker": "Lila Nachtigall, MD, NCMP",
            "Location": "New York, NY",
            "Name of PDF File": "P-26.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Women and Cardiovascular Disease: Progress made since the Women’s Health Initiative",
            "Speaker": "Nancy Ann Phillips, MD",
            "Location": "New Brunswick, NJ",
            "Name of PDF File": "P-27.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Characterizing Breast Sensory Function in Pre- and Menopausal Women",
            "Speaker": "El Pinkerton, MPH",
            "Location": "Chicago, IL",
            "Name of PDF File": "P-28.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Novel metrics of high density lipoprotein and cognitive function among perimenopausal women in the Study of Women’s Health Across the Nation (SWAN) HDL ancillary study",
            "Speaker": "Meiyuzhen Qi, MPH",
            "Location": "Pittsburgh, PA",
            "Name of PDF File": "P-29.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "A double-blind, randomized, placebo-controlled trial of suvorexant for the treatment of hot flash-associated insomnia in midlife women",
            "Speaker": "Shadab A Rahman, PhD",
            "Location": "Boston, MA",
            "Name of PDF File": "P-30.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Women’s Experience of The Late Reproductive Stage: Findings from the Women Living Better Survey",
            "Speaker": "Marcie Richardson, MD",
            "Location": "Jamaica Plain, MA",
            "Name of PDF File": "P-31.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Genitourinary Symptoms in Breast Cancer Survivors: Prevalence, Correlates, and Relationship with Sexual Functioning",
            "Speaker": "Ying Sheng, PhD",
            "Location": "Indianapolis, IN",
            "Name of PDF File": "P-32.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Segesterone Acetate/Ethinyl Estradiol Contraceptive Vaginal System (SA/EE; CVS): An Option That May Be Suitable For Perimenopausal Women",
            "Speaker": "James Simon, MD, CCD, NCMP, IF, FACOG",
            "Location": "WA, DC",
            "Name of PDF File": "P-33.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Burden of Illness in Women with a Diagnosis of Hypoactive Sexual Desire Disorder",
            "Speaker": "James Simon, MD, CCD, NCMP, IF, FACOG",
            "Location": "WA, DC",
            "Name of PDF File": "P-34.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Safety of transdermal hormone therapy in menopausal women at increased risk for venous thromboembolism",
            "Speaker": "Talia Sobel, MD",
            "Location": "Baltimore, MD",
            "Name of PDF File": "P-35.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Body Mass Index and Percentage Body Fat Are Negatively Associated with Severe Dyspareunia in Japanese Post-menopausal Women",
            "Speaker": "Masakazu Terauchi, MD, PhD",
            "Location": "Tokyo, Japan",
            "Name of PDF File": "P-36.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Women’s Health Network: An Evaluation of a Community Program",
            "Speaker": "Inneke L. Vargas",
            "Location": "Wichita, KS",
            "Name of PDF File": "P-37.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "A Novel Curriculum to Improve Resident Knowledge and Comfort with Menopause Care",
            "Speaker": "Kimberly Vesco, MD, MPH",
            "Location": "Portland, OR",
            "Name of PDF File": "P-38.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Real-world Outcomes of Patients New to Osteoporosis Therapies",
            "Speaker": "Setareh Williams",
            "Location": "Wayne, PA",
            "Name of PDF File": "P-39.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "The Late Reproductive Stage: A Scoping Review",
            "Speaker": "Nancy Fugate Woods, PhD, RN",
            "Location": "Seattle, WA",
            "Name of PDF File": "P-40.pdf",
            "QA-CDN": "https://qa-assets.posterview.com/wkinternal/2020/1/abstract/",
            "Prod CDN Link": "https://assets.posterview.com"
        }
    ]
	
	}

// New script start as excel sheet end 09/16/2020


// New script start as excel sheet start

/*
var NamsResultsObj = {
    "AbstractData": [
        {
            "Category": "Speaker Presentation",
            "Session Title": "Menopause 101 Course—Building the Foundation",
            "Lecture Title": "Menopause 101: How to Initiate Treatment",
            "Speaker": "Risa Kagan, MD, FACOG, CCD, NCMP",
            "Location": "Berkeley, California",
            "Name of PDF File": "Kagan101.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Menopause 101 Course—Building the Foundation",
            "Lecture Title": "Menopause 101: Dose, Route, and Formulation",
            "Speaker": "Gloria A. Richard-Davis, MD, MBA, NCMP, FACOG",
            "Location": "Little Rock, Arkansas",
            "Name of PDF File": "RichardDavis101.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Menopause 101 Course—Building the Foundation",
            "Lecture Title": "Hormone Contraception in Older Reproductive Women and Transition to Hormone Therapy",
            "Speaker": "Andrew M. Kaunitz, MD, FACOG, NCMP",
            "Location": "Jacksonville, Florida",
            "Name of PDF File": "Kaunitz101.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Menopause 101 Course—Building the Foundation",
            "Lecture Title": "Maintaining Wellness in Perimenopause and Beyond",
            "Speaker": "Heather D. Hirsch, MD, MS, NCMP",
            "Location": "Boston, Massachusetts",
            "Name of PDF File": "Hirsch101.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Menopause 101 Course—Building the Foundation",
            "Lecture Title": "Nonhormone Management of Hot Flashes",
            "Speaker": "Catherine Hansen, MD, FRCSC, FACOG, MPH, NCMP",
            "Location": "Houston, Texas",
            "Name of PDF File": "Hansen101.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Menopause 101 Course—Building the Foundation",
            "Lecture Title": "Sexual Health: Libido and Testosterone",
            "Speaker": "Brooke M. Faught, DNP, WHNP-BC, NCMP, IF",
            "Location": "Nashville, Tennessee",
            "Name of PDF File": "Faught101.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Pre-Meeting Symposium—Menopause Symptom Management in 2020: One Size Doesn't Fit All",
            "Lecture Title": "The Burden of Menopause on Vasomotor Symptoms and Genitourinary Syndrome of Menopause",
            "Speaker": "Wen Shen, MD, MPH",
            "Location": "Baltimore, Maryland",
            "Name of PDF File": "ShenPre.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Pre-Meeting Symposium—Menopause Symptom Management in 2020: One Size Doesn't Fit All",
            "Lecture Title": "Hormone Therapy in 2020",
            "Speaker": "Jan L. Shifren, MD, NCMP",
            "Location": "Boston, Massachusetts",
            "Name of PDF File": "ShifrenPre.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Pre-Meeting Symposium—Menopause Symptom Management in 2020: One Size Doesn't Fit All",
            "Lecture Title": "Nonpharmacologic Therapies for Vasomotor Symptoms",
            "Speaker": "Janet S. Carpenter, PhD, RN, FAAN",
            "Location": "Indianapolis, Indiana",
            "Name of PDF File": "CarpenterPre.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Pre-Meeting Symposium—Menopause Symptom Management in 2020: One Size Doesn't Fit All",
            "Lecture Title": "New Nonhormone Therapies for Vasomotor Symptoms",
            "Speaker": "Susan D. Reed, MD, MPH, MS",
            "Location": "Seattle, Washington",
            "Name of PDF File": "ReedPre.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Pre-Meeting Symposium—Menopause Symptom Management in 2020: One Size Doesn't Fit All",
            "Lecture Title": "New Hormone Therapies for Vasomotor Symptoms",
            "Speaker": "Hugh S. Taylor, MD",
            "Location": "New Haven, Connecticut",
            "Name of PDF File": "TaylorPre.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Pre-Meeting Symposium—Menopause Symptom Management in 2020: One Size Doesn't Fit All",
            "Lecture Title": "Compounded Bioidentical Hormone Therapy",
            "Speaker": "Cynthia A. Stuenkel, MD, NCMP",
            "Location": "La Jolla, California",
            "Name of PDF File": "StuenkelPre.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Pre-Meeting Symposium—Menopause Symptom Management in 2020: One Size Doesn't Fit All",
            "Lecture Title": "Management of Symptoms in Perimenopause",
            "Speaker": "Pelin Batur, MD, FACP, NCMP, CCD",
            "Location": "Cleveland, Ohio",
            "Name of PDF File": "BaturPre.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Pre-Meeting Symposium—Menopause Symptom Management in 2020: One Size Doesn't Fit All",
            "Lecture Title": "Genitourinary Syndrome of Menopause Management",
            "Speaker": "Amanda L. Clark, MD, MCR, NCMP",
            "Location": "Portland, Oregon",
            "Name of PDF File": "ClarkPre.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 1—Novel Risk Factors for Cardiovascular Disease in Women",
            "Lecture Title": "Human Social Genomics: Implications for Cardiovascular Disease in Women",
            "Speaker": "Steven W. Cole, PhD",
            "Location": "Los Angeles, California",
            "Name of PDF File": "Cole1.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 1—Novel Risk Factors for Cardiovascular Disease in Women",
            "Lecture Title": "Novel Phenotypes of Cardiovascular Disease in Women",
            "Speaker": "C. Noel Bairey Merz, MD, FACCD",
            "Location": "Los Angeles, California",
            "Name of PDF File": "BaireyMerz1.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 1—Novel Risk Factors for Cardiovascular Disease in Women",
            "Lecture Title": "Women's Cardiovascular Health at Midlife: The Role of Hot Flashes, Sleep Problems, and Trauma",
            "Speaker": "Rebecca C. Thurston, PhD",
            "Location": "Pittsburgh, Pennsylvania",
            "Name of PDF File": "Thurston1.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 2—Hormones of Menopause",
            "Lecture Title": "FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes?",
            "Speaker": "T. Rajendra Kumar, PhD",
            "Location": "Aurora, Colorado",
            "Name of PDF File": "Kumar2.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 2—Hormones of Menopause",
            "Lecture Title": "Antimullerian Hormone: How Can We Use It Clinically?",
            "Speaker": "Genevieve S. Neal-Perry, MD, PhD",
            "Location": "Chapel Hill, North Carolina",
            "Name of PDF File": "NealPerry2.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 2—Hormones of Menopause",
            "Lecture Title": "Estradiol and Estrone: Changing Ratios After Menopause",
            "Speaker": "Richard J. Auchus, MD, PhD",
            "Location": "Ann Arbor, Michigan ",
            "Name of PDF File": "Auchus2.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 3—Weight, Weight, Don't Tell Me",
            "Lecture Title": "Body Composition and Fat Patterning: The Role of Age and Estrogen",
            "Speaker": "Wendy M. Kohrt, PhD",
            "Location": "Aurora, Colorado",
            "Name of PDF File": "Kohrt3.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 3—Weight, Weight, Don't Tell Me",
            "Lecture Title": "Medical and Surgical Management of Weight Loss",
            "Speaker": "Daniel H. Bessesen, MD",
            "Location": "Aurora, Colorado",
            "Name of PDF File": "Bessesen3.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 4—Sleep and Anxiety: Sleep Perchance to Dream",
            "Lecture Title": "Sleep, Appetite Regulation, and Weight Gain",
            "Speaker": "Kelly Glazer Baron, PhD, MPH, DBSM",
            "Location": "Salt Lake City, Utah",
            "Name of PDF File": "Baron4.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 4—Sleep and Anxiety: Sleep Perchance to Dream",
            "Lecture Title": "Women, Anxiety, and Menopause: Novel Treatments for Anxiety Disorders",
            "Speaker": "Andrew M. Novick, MD, PhD",
            "Location": "Aurora, Colorado",
            "Name of PDF File": "Novick4.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 5—Cognition and Menopause: Putting Your Best Brain Forward",
            "Lecture Title": "How to KEEP Sharp: The KEEPS Cognition Follow-Up",
            "Speaker": "Kejal Kantarci, MD, MS",
            "Location": "Rochester, Minnesota",
            "Name of PDF File": "Kantarci5.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 6—Caution to Menopause Practitioners Addressing Sexual Health Concerns: Look Both Ways!",
            "Lecture Title": "Caution to Menopause Practitioners Addressing Sexual Health Concerns: Look Both Ways!",
            "Speaker": "Sheryl A. Kingsberg, PhD; Stanley E. Althof, PhD",
            "Location": "Cleveland, Ohio; Greenacres, Florida",
            "Name of PDF File": "KingsbergAlthof6.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 7—Special Needs of Women When Menopause Comes Early: Primary Ovarian Insufficiency and Contraception",
            "Lecture Title": "Surgical Menopause and Primary Ovarian Insufficiency",
            "Speaker": "Wendy Wolfman, MD, FRCSC, FACOG",
            "Location": "Toronto, Ontario, Canada",
            "Name of PDF File": "Wolfman7.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 7—Special Needs of Women When Menopause Comes Early: Primary Ovarian Insufficiency and Contraception",
            "Lecture Title": "Contraception",
            "Speaker": "Jeffrey T. Jensen, MD, MPH",
            "Location": "Portland, Oregon",
            "Name of PDF File": "Jensen7.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 8—New Guidelines and How to Apply Them",
            "Lecture Title": "NAMS Genitourinary Syndrome of Menopause Position Statement",
            "Speaker": "Stephanie S. Faubion, MD, MBA, FACP, NCMP, IF",
            "Location": "Jacksonville, Florida",
            "Name of PDF File": "Faubion8.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 8—New Guidelines and How to Apply Them",
            "Lecture Title": "Female Pattern Hair Loss and Androgen Excess: Review of Report From the Multidisciplinary Androgen Excess and PCOS Committee",
            "Speaker": "Heather Huddleston, MD",
            "Location": "San Francisco, California",
            "Name of PDF File": "Huddleston8.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 8—New Guidelines and How to Apply Them",
            "Lecture Title": "NAMS Osteoporosis Position Statement",
            "Speaker": "Michael R. McClung, MD, FACP, FASBMR, FACE",
            "Location": "Portland, Oregon",
            "Name of PDF File": "McClung8.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 9—Cardiovascular Disease and Women",
            "Lecture Title": "Heart Fat and Menopause",
            "Speaker": "Samar R. El Khoudary, PhD, MPH, BPharm, FAHA",
            "Location": "Pittsburgh, Pennsylvania",
            "Name of PDF File": "ElKhoudary9.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Plenary Symposium 9—Cardiovascular Disease and Women",
            "Lecture Title": "Heart Disease: Distinctions in Women",
            "Speaker": "Judith Regensteiner, PhD",
            "Location": "Aurora, Colorado",
            "Name of PDF File": "Regensteiner9.pdf"
        },
        {
            "Category": "Special Lectures",
            "Session Title": "Keynote Address",
            "Lecture Title": "What Is Wellness?",
            "Speaker": "James O. Hill, PhD",
            "Location": "Birmingham, Alabama",
            "Name of PDF File": "Hill.pdf"
        },
        {
            "Category": "Special Lectures",
            "Session Title": "NAMS/Kenneth W. Kleinman Endowed Lecture",
            "Lecture Title": "Social Media and Menopause: Separating Health From Hype and Why It Matters",
            "Speaker": "Jen Gunter MD, FRCS(C), FACOG, DABPM, ABPMR ",
            "Location": "San Francisco, California",
            "Name of PDF File": "Gunter.pdf"
        },
        {
            "Category": "Special Lectures",
            "Session Title": "NAMS/Pfizer Wulf H. Utian Endowed Lecture",
            "Lecture Title": "Ghosts From the Past: Impact of Childhood Adversity on Mood and Cognition at Menopause",
            "Speaker": "C. Neill Epperson, MD",
            "Location": "Aurora, Colorado",
            "Name of PDF File": "Epperson.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Evaluation of a Discussion Guide to Promote Understanding of Menopause and Informed Decision Making",
            "Speaker": "Emma Andrews, PharmD",
            "Location": "New York City, NY",
            "Name of PDF File": "S-1.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Reproductive period duration and cognitive function in postmenopausal Hispanic/Latina women in the HCHS/SOL",
            "Speaker": "Yamnia Ivelisse Cortés, PhD, MPH, FNP-BC",
            "Location": "Chapel Hill, NC",
            "Name of PDF File": "S-2.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "HDL composition and function in relation with calcium density of coronary artery plaque among women transitioning through menopause. The SWAN HDL ancillary study",
            "Speaker": "Samar R. El Khoudary, PhD, MPH, Bpharm, FAHA",
            "Location": "Pittsburgh, PA",
            "Name of PDF File": "S-3.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Cholesterol efflux capacity of HDL particles over the menopause transition: The SWAN HDL ancillary study",
            "Speaker": "Samar R. El Khoudary, PhD, MPH, Bpharm, FAHA",
            "Location": "Pittsburgh, PA",
            "Name of PDF File": "S-4.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Fractional CO2 Laser Therapy, a Promising Treatment Alternative for Vulvovaginal Symptoms in Menopause, Breast Cancer and Lichen Sclerosus",
            "Speaker": "Alyssa Gardner, MD",
            "Location": "Waunakee, WI",
            "Name of PDF File": "S-5.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Waist to hip ratio predicts cognitive trajectory regardless of hormone therapy use: Analysis from Kronos Early Estrogen Prevention Study’s Cognitive and Mood Ancillary Study (KEEPS-Cog)",
            "Speaker": "Carey E. Gleason, PhD",
            "Location": "Madison, WI",
            "Name of PDF File": "S-6.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Postmenopausal Dyspareunia – Where Does It Hurt?",
            "Speaker": "Martha F Goetsch, MD, MPH",
            "Location": "Portland, OR",
            "Name of PDF File": "S-7.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "A novel, non-hormonal, non-invasive ultrasound device is effective in treating the symptoms of vaginal dryness associated with genitourinary syndrome of menopause (GSM)",
            "Speaker": "Martha Hickey, MD",
            "Location": "Melbourne, Victoria, Australia",
            "Name of PDF File": "S-8.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "NT-814, a Non-hormonal Dual NK1,3 Receptor Antagonist Markedly Improves Sleep, Mood and Quality of Life in Post-Menopausal Women; Results of a Randomised, Double-Blind, Placebo-Controlled Study (SWITCH-1)",
            "Speaker": "Hadine Joffe, MD, MSc",
            "Location": "Boston, MA",
            "Name of PDF File": "S-9.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Effect of Vasomotor Symptom Frequency and Comorbidities on Sleep Quality Among Women in Midlife: a Retrospective Analysis of the US SWAN Database",
            "Speaker": "Risa Kagan, MD, FACOG, CCD, NCMP",
            "Location": "Berkeley, CA",
            "Name of PDF File": "S-10.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Higher blood pressure is associated with loss of white matter integrity and higher Alzheimer’s tau biomarkers in postmenopausal women of the KEEPS Continuation Study",
            "Speaker": "Firat Kara, PhD",
            "Location": "Rochester, MN",
            "Name of PDF File": "S-11.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Effect of estradiol therapy on markers of inflammation: Results from the Early vs Late Intervention Trial with Estradiol (ELITE)",
            "Speaker": "Roksana Karim, PhD, MBBS",
            "Location": "La Crescenta, CA",
            "Name of PDF File": "S-12.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "A clinical study to evaluate Elismetrep (TRPM8 antagonist), a non-hormonal drug for the treatment of vasomotor symptoms in postmenopausal women",
            "Speaker": "Sheryl Kingsberg, PhD",
            "Location": "Cleveland , OH",
            "Name of PDF File": "S-13.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Anti-Müllerian hormone (AMH) and markers of oxidative stress, inflammation, and endothelial dysfunction",
            "Speaker": "Melissa F. Wellons , MD, MHS",
            "Location": "Nashville, TN",
            "Name of PDF File": "S-14.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Global Prospective Survey of Women with Vasomotor Symptoms Associated with Menopause: US Findings",
            "Speaker": "Robin Kroll, MD, NCMP",
            "Location": "Seattle, WA",
            "Name of PDF File": "S-15.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Real-life impact of menopause on midlife women’s health and well-being: A comprehensive survey of U.S. women’s health choices, behaviors and experiences during various stages of menopause.",
            "Speaker": "Monica P Mallampalli, PhD",
            "Location": "Red Bank, NJ",
            "Name of PDF File": "S-16.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Associations of abdominal and intrathoracic fat depots with high-density lipoprotein metrics in midlife women: The SWAN Study",
            "Speaker": "Alexis Nasr, MD",
            "Location": "Pittsburgh, PA",
            "Name of PDF File": "S-17.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "The Severity of Vasomotor Symptoms and Number of Menopausal Symptoms in Postmenopausal Women and Select Clinical Health Outcomes in the Women’s Health Initiative Calcium and Vitamin D Randomized Clinical Trial",
            "Speaker": "Matthew Stephen  Nudy, MD",
            "Location": "Hummelstown, PA",
            "Name of PDF File": "S-18.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Female Sexual Function and Urinary Incontinence: Six Month Follow-up after High-Intensity Focused Electromagnetic Procedure",
            "Speaker": "Julene B. Samuels, MD, FACS",
            "Location": "Prospect, KY",
            "Name of PDF File": "S-19.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Bioenergetic Markers and Cognition in Peri- and Postmenopausal Women",
            "Speaker": "Rachel A Schroeder, BS",
            "Location": "Chicago, IL",
            "Name of PDF File": "S-20.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "NT-814, a Non-Hormonal Dual Neurokinin 1,3 Receptor Antagonist Markedly Improves Hot Flashes in Post-Menopausal Women; Results of a Randomised, Double-Blind, Placebo-Controlled Study",
            "Speaker": "James Simon, MD, CCD, NCMP, IF, FACOG",
            "Location": "Washington, DC",
            "Name of PDF File": "S-21.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "Effect of hormone therapy on lipoprotein subfractions in early and late postmenopausal women",
            "Speaker": "Intira Sriprasert, MD",
            "Location": "Alhambra, CA",
            "Name of PDF File": "S-22.pdf"
        },
        {
            "Category": "Oral Abstract",
            "Session Title": "Oral Abstract Presentations",
            "Lecture Title": "How important is sex to women during midlife?",
            "Speaker": "Holly Nicole Thomas, MD, MS",
            "Location": "Pittsburgh, PA",
            "Name of PDF File": "S-23.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "The Effect of Early Menopause on the Development of Osteoporosis in the Canadian Longitudinal Study on Aging.",
            "Speaker": "Alice Buwembo, MD, MSc",
            "Location": "Hamilton, ON",
            "Name of PDF File": "P-1.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "A MsFLASH Investigation of Self-reported Menopausal Palpitations Distress",
            "Speaker": "Janet S. Carpenter, PhD, RN, FAAN",
            "Location": "Indianapolis, IN",
            "Name of PDF File": "P-2.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "The effect of menopause on metabolic syndrome: Cross-sectional results from the Canadian Longitudinal Study on Aging",
            "Speaker": "Marie Katherine Christakis, MD, MPH",
            "Location": "East  York, ON",
            "Name of PDF File": "P-3.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Resident Physician Impressions of Menopause Core Content Delivered by Podcast",
            "Speaker": "Amanda Clark, MD, MCR, NCMP",
            "Location": "Portland, OR",
            "Name of PDF File": "P-4.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "A Novel Consumer Based Product for Vasomotor Symptoms (VMS) of Menopause; Prototype Trial.",
            "Speaker": "Alyssa Dweck, MS, MD, FACOG",
            "Location": "Scarsdale, NY",
            "Name of PDF File": "P-5.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Qualitative Study of the Burden of Vasomotor Symptoms Associated With Menopause and Content Validity of Two PROMIS Sleep Measures in Menopausal Women",
            "Speaker": "Marci English, MPH",
            "Location": "Northbrook, IL",
            "Name of PDF File": "P-6.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "PERCEPTION OF MENOPAUSE IN SOUTH AMERICA",
            "Speaker": "Vivian L Ernst - Baez, MD",
            "Location": "Basking Ridge, NJ",
            "Name of PDF File": "P-7.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Examining the Long-Term Brain Effects of Menopausal Hormone Therapy: KEEPS Continuation Study",
            "Speaker": "Carola Ferrer Simó, MPH",
            "Location": "Madison, WI",
            "Name of PDF File": "P-8.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Dyspareunia and the resulting impairment of daily life improves over time in equal measure when using a hormone-free moisturizing vaginal cream or a standard estriol cream",
            "Speaker": "Susana Garcia de Arriba, MD",
            "Location": "Bielefeld, Germany",
            "Name of PDF File": "P-9.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "  Cannabis use for menopause symptom management among midlife women Veterans",
            "Speaker": "Carolyn Gibson, PhD, MPH",
            "Location": "San Francisco, CA",
            "Name of PDF File": "P-10.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "The Effects of a 17β-estradiol, Softgel, Vaginal Insert on Vulvar and Vaginal Atrophy (VVA), Including Moderate to Severe Dyspareunia and Vaginal Dryness in Postmenopausal Women > 60 Years of Age",
            "Speaker": "Steven R Goldstein, MD, FACOG, CCD, NCMP",
            "Location": "New York, NY",
            "Name of PDF File": "P-11.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "SJX-653 Demonstrates Potent NK3 Antagonism Across Nonclinical and Clinical Studies",
            "Speaker": "Philip Graham, PhD",
            "Location": "Boston, MA",
            "Name of PDF File": "P-12.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Metabolic Risk Factors and Cognitive Function in Midlife Women from Sub-Saharan Africa",
            "Speaker": "Nicole Gusti Jaff, PhD, NCMP",
            "Location": "Johannesburg, South Africa",
            "Name of PDF File": "P-13.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Trauma and Sleep Problems Over Midlife in Women",
            "Speaker": "Karen P Jakubowski, PhD",
            "Location": "Pittsburgh, PA",
            "Name of PDF File": "P-14.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Lifetime History of Intimate Partner Violence and Current Clinical Insomnia Among Midlife Women Veterans",
            "Speaker": "Karen P Jakubowski, PhD",
            "Location": "Pittsburgh, PA",
            "Name of PDF File": "P-15.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Implementation of Standardized Practice Guideline May Allow Stabilization of Serum Hormone Levels and Impact the Incidence of Side Effects in Women Taking Custom-Compounded Hormone Therapy",
            "Speaker": "Xuezhi Jiang, MD, PhD",
            "Location": "Reading, PA",
            "Name of PDF File": "P-16.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Fezolinetant Attenuates Hot Flash-like Symptoms via Inhibition of Neuronal Activity in the Median Preoptic Nucleus in Ovariectomized Rats",
            "Speaker": "Seiji Kaku",
            "Location": "Tsukuba, Ibaraki, Japan",
            "Name of PDF File": "P-17.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Postchemotherapy serum FSH as a predictor of ovarian function recovery in young cancer patients",
            "Speaker": "Hye Kyeong Kim, PhD",
            "Location": "Seoul, South Korea",
            "Name of PDF File": "P-18.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "KAP (knowledge, attitude and practice) survey on THM in the Santiago (Chile) population.",
            "Speaker": "Pablo A Lavín, MD, MPH, MSc",
            "Location": "Santiago, Chile",
            "Name of PDF File": "P-19.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Nutrient Gaps for Women of Menopausal Transition Age in the United States",
            "Speaker": "LeeCole Legette, PhD",
            "Location": "West Hills, CA",
            "Name of PDF File": "P-20.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Differences in patient-reported rates of hormone therapy use by provider specialty",
            "Speaker": "Megan McCarty, MD",
            "Location": "Pittsburgh, PA",
            "Name of PDF File": "P-21.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Pelvic Floor Clinic model; collaborative and convenient delivery provides improvement in pelvic floor symptoms, mood, and quality of life.",
            "Speaker": "Jean Marie Frances McGowan, MD, NCMP",
            "Location": "Fargo, ND",
            "Name of PDF File": "P-22.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Adverse Childhood Experiences and Menopause Stage Impact Mood, Cognition, and Basal Inflammatory Markers",
            "Speaker": "Christina Metcalf, MA",
            "Location": "Aurora, CO",
            "Name of PDF File": "P-24.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "A survey of healthcare provider knowledge, attitudes, and preferences in management of Genitourinary Syndrome of Menopause (GSM) in the Mid-South",
            "Speaker": "Joshua Morris, MD, MA",
            "Location": "Memphis, TN",
            "Name of PDF File": "P-25.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Patient Satisfaction With the Use of Revaree to Treat Vaginal Atrophy Symptoms",
            "Speaker": "Lila Nachtigall, MD, NCMP",
            "Location": "New York, NY",
            "Name of PDF File": "P-26.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Women and Cardiovascular Disease: Progress made since the Women’s Health Initiative",
            "Speaker": "Nancy Ann Phillips, MD",
            "Location": "New Brunswick, NJ",
            "Name of PDF File": "P-27.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Characterizing Breast Sensory Function in Pre- and Menopausal Women",
            "Speaker": "El Pinkerton, MPH",
            "Location": "Chicago, IL",
            "Name of PDF File": "P-28.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Novel metrics of high density lipoprotein and cognitive function among perimenopausal women in the Study of Women’s Health Across the Nation (SWAN) HDL ancillary study",
            "Speaker": "Meiyuzhen Qi, MPH",
            "Location": "Pittsburgh, PA",
            "Name of PDF File": "P-29.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "A double-blind, randomized, placebo-controlled trial of suvorexant for the treatment of hot flash-associated insomnia in midlife women",
            "Speaker": "Shadab A Rahman, PhD",
            "Location": "Boston, MA",
            "Name of PDF File": "P-30.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Women’s Experience of The Late Reproductive Stage: Findings from the Women Living Better Survey",
            "Speaker": "Marcie Richardson, MD",
            "Location": "Jamaica Plain, MA",
            "Name of PDF File": "P-31.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Genitourinary Symptoms in Breast Cancer Survivors: Prevalence, Correlates, and Relationship with Sexual Functioning",
            "Speaker": "Ying Sheng, PhD",
            "Location": "Indianapolis, IN",
            "Name of PDF File": "P-32.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Segesterone Acetate/Ethinyl Estradiol Contraceptive Vaginal System (SA/EE; CVS): An Option That May Be Suitable For Perimenopausal Women",
            "Speaker": "James Simon, MD, CCD, NCMP, IF, FACOG",
            "Location": "Washington, DC",
            "Name of PDF File": "P-33.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Burden of Illness in Women with a Diagnosis of Hypoactive Sexual Desire Disorder",
            "Speaker": "James Simon, MD, CCD, NCMP, IF, FACOG",
            "Location": "Washington, DC",
            "Name of PDF File": "P-34.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Safety of transdermal hormone therapy in menopausal women at increased risk for venous thromboembolism",
            "Speaker": "Talia Sobel, MD",
            "Location": "Baltimore, MD",
            "Name of PDF File": "P-35.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Body Mass Index and Percentage Body Fat Are Negatively Associated with Severe Dyspareunia in Japanese Post-menopausal Women",
            "Speaker": "Masakazu Terauchi, MD, PhD",
            "Location": "Tokyo, Japan",
            "Name of PDF File": "P-36.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Women’s Health Network: An Evaluation of a Community Program",
            "Speaker": "Inneke L. Vargas",
            "Location": "Wichita, KS",
            "Name of PDF File": "P-37.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "A Novel Curriculum to Improve Resident Knowledge and Comfort with Menopause Care",
            "Speaker": "Kimberly Vesco, MD, MPH",
            "Location": "Portland, OR",
            "Name of PDF File": "P-38.pdf"
        },
        {
            "Category": "Poster Presentation",
            "Session Title": "Poster Abstract Presentations",
            "Lecture Title": "Real-world Outcomes of Patients New to Osteoporosis Therapies",
            "Speaker": "Setareh Williams",
            "Location": "Wayne, PA",
            "Name of PDF File": "P-39.pdf"
        },
        {
            "Category": "Speaker Presentation",
            "Session Title": "Poster Abstract Presentations 123",
            "Lecture Title": "The Late Reproductive Stage: A Scoping Review 123",
            "Speaker": "Nancy Fugate Woods, PhD, RN 123",
            "Location": "Seattle, WA 123",
            "Name of PDF File": "P-40.pdf 123"
        }
    ]
}

*/
    
/*
      const loader = new Preloader();
        $.post( "/nams2020dev/Style%20Library/NamsJsonAbstracts.txt", function( data ) {
            NamsResultsObj = JSON.parse(data);
            AbstractsdataFunction()
            const hideLoader = () => {
                loader.hide();
            };
    });
*/
    
var Results = "<div class='row mb-5'><div class='col-md-7 col-lg-8 col-xl-9'><p class='wk-size-4 mt-8 loginhedding' id='ResultsCount'>110 Results</p></div><div class='col-md-5 col-lg-4 col-xl-3 '>  <wk-select label='Show All' class='wk-field-select-container'><select class='wk-field-select selectW-85' id='select_filter'><option value='All'>All</option></select> </wk-select></div></div></div></div><div class='col-md-12 mb-5 p-0 smp-0 mx-auto'><div id='ResultData'>"
document.getElementById("ResultsSection").innerHTML = Results;
var Results_Count = 0;
Results_Count = NamsResultsObj.AbstractData.length
document.getElementById("ResultsCount").innerHTML = Results_Count + "  Results";
equal_cols('.card');

  var Categorylength = [];
    for (var i = 0; i < NamsResultsObj.AbstractData.length; i++) {
        var name = NamsResultsObj.AbstractData[i].Category;
        if(Categorylength.indexOf(name)==-1)
              Categorylength.push(name);
    }


let dropdown = document.getElementById('select_filter');
dropdown.length = 0;
let defaultOption = document.createElement('option');
defaultOption.text = 'All';
defaultOption.value = 'All';
dropdown.add(defaultOption);
dropdown.selectedIndex = 0;
for (var r = 0, len=Categorylength.length; r < len; r++) {
    var option = document.createElement('option');
      option.text = Categorylength[r];
      option.value = Categorylength[r];
      dropdown.add(option);
}
function equal_cols(el){
    var h = 0;
    $(el).each(function(){
        $(this).css({'height':'auto'});
        if($(this).outerHeight() > h)
        {
            h = $(this).outerHeight();
        }
    });
    $(el).each(function(){
        $(this).css({'height':h + 30});
    });
}

function change_Showselect(selectdata) {
var hedding = "";
    if (selectdata) {
        $('.categoryname').hide();
        if (selectdata == "All") {
            $('.categoryname').show();
            document.getElementById("ResultsCount").innerHTML = NamsResultsObj.AbstractData.length  + "  Results";
        } else {
            $('.categoryname.' + selectdata.replace(/\s/g, "")).show();
            var Categorycountonchange = 0
         for (var C = 0; C < NamsResultsObj.AbstractData.length; C++) {
            if(NamsResultsObj.AbstractData[C].Category == selectdata){
                Categorycountonchange += 1
            }
         }
         document.getElementById("ResultsCount").innerHTML = Categorycountonchange  + "  Results";
        }

        equal_cols('.card');
        setTimeout(function() {
            equal_cols('.card');
        }, 250);

    }else{
   
            const windowhost = window.location.href
            const hostresult = windowhost.indexOf('dev') > 0 || windowhost.indexOf("qa");
            
            
    for (var i = 0; i < Categorylength.length; i++) {
        var categorydata = Categorylength[i]
        var Speaker = "<div class='row'>";
        var Categorycount = 0
         for (var G = 0; G < NamsResultsObj.AbstractData.length; G++) {
        var name = NamsResultsObj.AbstractData[i].Category;
        
        if(NamsResultsObj.AbstractData[G].Category == categorydata){
            Categorycount += 1
            var downloadPDF = "";
            if(hostresult){
                  downloadPDF = NamsResultsObj.AbstractData[G]["QA-CDN"] + NamsResultsObj.AbstractData[G]["Name of PDF File"]
            }else{
                downloadPDF = NamsResultsObj.AbstractData[G]["Prod-CDN"] + NamsResultsObj.AbstractData[G]["Name of PDF File"]
            }
            Speaker += "<div class='col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-4'><div class='card'><div class='card-content'> <div class='wk-tag-blue'>" + NamsResultsObj.AbstractData[G]["Category"] + "</div>" + "<div class='wk-card-subtitle mt-2'>" + NamsResultsObj.AbstractData[G]["Session Title"] + "</div>" + "<div class='wk-docs-paragraph-sample wk-margins'><p class='mb-5 mt-4 card-desc'>" + NamsResultsObj.AbstractData[G]["Lecture Title"] + "</p></div>" + "<h4 class='wk-card-subtitle'>" + NamsResultsObj.AbstractData[G]["Speaker"] + "</h3>" + "<div class='wk-card-subtitle-italic'>" + NamsResultsObj.AbstractData[G]["Location"] + "</div>" + "<div class='wk-text-danger-Download mt-5 pt-2'>" + "<a href=" + "'" + downloadPDF + "'" + " + " + "class='Download-text mt-3' target='_blank'>  Download  </a>" + "</div>" + "</div></article></div></div>";
        }       
    }
    
     var cssclasname = 'Abstractshedding categoryname ' + categorydata.replace(/\s/g, "")
     hedding +=  "<div class= " + "'" +  cssclasname  + "'" + ">"
     hedding += "<h3 class='wk-col-12 mb-4 pb-5'> " + categorydata + " ("+ Categorycount +")" + "</h3>"
     Speaker += "</div></div></div>"
     hedding += Speaker 
        
        document.getElementById("ResultData").innerHTML = hedding;
    }
    equal_cols('.card');
    setTimeout(function() {
        equal_cols('.card');
    }, 250);
}

      }

change_Showselect();
document.getElementById("select_filter").onchange = function() {change_Showselect(this.value)};
if($('.container-fluid').height() < $(window).height()){
    $('.row.footer-container').addClass('footerfixedpos')
}else{
    $('.row.footer-container').removeClass('footerfixedpos')
}



// New script start as excel sheet end 














   /*  const loader = new Preloader();
		$.post( "/nams2020dev/Style%20Library/NamsJsonAbstracts.txt", function( data ) {
            NamsResultsObj = JSON.parse(data);
            AbstractsdataFunction()
            const hideLoader = () => {
                loader.hide();
            };
	}); */
	
	/*

    var NamsResultsObj = {
        "Speaker":{
        "categoryname":"Speaker Presentations",
        "categorydata":[
            {
            "name":"SPEAKER PRESENTATIONS",
            "presentationtitle":"Plenary Symposium 2—Hormones of Menopause",
            "description":"FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes And Other Factors?",
            "speaker":"T Rajendra Kumar, PhD",
            "location":"Aurora, Colorado",
            "Download": "Download"
            },
            {
            "name":"SPEAKER PRESENTATIONS",
            "presentationtitle":"Plenary Symposium 2—Hormones of Menopause",
            "description":"FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes And Other Factors?",
            "speaker":"2-T Rajendra Kumar, PhD",
            "location":"2-Aurora, Colorado",
            "Download": "Download"
            },
            {
            "name":"SPEAKER PRESENTATIONS",
            "presentationtitle":"Plenary Symposium 2—Hormones of Menopause",
            "description":"FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes And Other Factors?",
            "speaker":"3-T Rajendra Kumar, PhD",
            "location":"3-Aurora, Colorado",
            "Download": "Download"
            },
            {
            "name":"SPEAKER PRESENTATIONS",
            "presentationtitle":"Plenary Symposium 2—Hormones of Menopause",
            "description":"FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes And Other Factors?",
            "speaker":"4-T Rajendra Kumar, PhD",
            "location":"4-Aurora, Colorado",
            "Download": "Download"
            },
            {
            "name":"SPEAKER PRESENTATIONS",
            "presentationtitle":"Plenary Symposium 2—Hormones of Menopause",
            "description":"FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes And Other Factors?",
            "speaker":"5-T Rajendra Kumar, PhD",
            "location":"5-Aurora, Colorado",
            "Download": "Download"
            },
            {
            "name":"SPEAKER PRESENTATIONS",
            "presentationtitle":"1-Plenary Symposium 2—Hormones of Menopause",
            "description":"1-FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes And Other Factors?",
            "speaker":"6-T Rajendra Kumar, PhD",
            "location":"6-Aurora, Colorado",
            "Download": "1-Download"
            },
            {
            "name":"SPEAKER PRESENTATIONS",
            "presentationtitle":"1-Plenary Symposium 2—Hormones of Menopause",
            "description":"1-FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes And Other Factors?",
            "speaker":"7-T Rajendra Kumar, PhD",
            "location":"7-Aurora, Colorado",
            "Download": "7-Download"
            },
            {
            "name":"SPEAKER PRESENTATIONS",
            "presentationtitle":"1-Plenary Symposium 2—Hormones of Menopause",
            "description":"1-FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes And Other Factors?",
            "speaker":"8-T Rajendra Kumar, PhD",
            "location":"8-Aurora, Colorado",
            "Download": "8-Download"
            }
            
        ]
        },
        "Abstracts":{
        "categoryname":"Oral Abstracts",
        "categorydata":[
            {
            "name":"Oral PRESENTATIONS",
            "presentationtitle":"Plenary Symposium 2—Hormones of Menopause",
            "description":"FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes And Other Factors?",
            "speaker":"T Rajendra Kumar, PhD",
            "location":"Aurora, Colorado",
            "Download": "Download"
            },
            {
            "name":"SPEAKER PRESENTATIONS",
            "presentationtitle":"1-Plenary Symposium 2—Hormones of Menopause",
            "description":"1-FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes And Other Factors?",
            "speaker":"1-T Rajendra Kumar, PhD",
            "location":"1-Aurora, Colorado",
            "Download": "1-Download"
            },
            {
            "name":"SPEAKER PRESENTATIONS",
            "presentationtitle":"3-Plenary Symposium 2—Hormones of Menopause",
            "description":"2-FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes And Other Factors?",
            "speaker":"2-T Rajendra Kumar, PhD",
            "location":"2-Aurora, Colorado",
            "Download": "2-Download"
            },
            {
            "name":"SPEAKER PRESENTATIONS",
            "presentationtitle":"3-Plenary Symposium 2—Hormones of Menopause",
            "description":"3-FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes And Other Factors?",
            "speaker":"3-T Rajendra Kumar, PhD",
            "location":"3-Aurora, Colorado",
            "Download": "3-Download"
            },
            {
            "name":"SPEAKER PRESENTATIONS",
            "presentationtitle":"4-Plenary Symposium 2—Hormones of Menopause",
            "description":"4-FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes And Other Factors?",
            "speaker":"4-T Rajendra Kumar, PhD",
            "location":"4-Aurora, Colorado",
            "Download": "4-Download"
            },
            {
            "name":"SPEAKER PRESENTATIONS",
            "presentationtitle":"4-Plenary Symposium 2—Hormones of Menopause",
            "description":"4-FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes And Other Factors?",
            "speaker":"5-T Rajendra Kumar, PhD",
            "location":"5-Aurora, Colorado",
            "Download": "5-Download"
            },
            {
            "name":"SPEAKER PRESENTATIONS",
            "presentationtitle":"4-Plenary Symposium 2—Hormones of Menopause",
            "description":"4-FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes And Other Factors?",
            "speaker":"6-T Rajendra Kumar, PhD",
            "location":"6-Aurora, Colorado",
            "Download": "6-Download"
            }
        ]
        },
        "Poster":{
        "categoryname":"Poster Presentations",
        "categorydata":[
            {
            "name":"Poster PRESENTATIONS",
            "presentationtitle":"Plenary Symposium 2—Hormones of Menopause",
            "description":"FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes And Other Factors?",
            "speaker":"T Rajendra Kumar, PhD",
            "location":"Aurora, Colorado",
            "Download": "Download"
            },
            {
            "name":"Poster PRESENTATIONS",
            "presentationtitle":"1-Plenary Symposium 2—Hormones of Menopause",
            "description":"1-FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes And Other Factors?",
            "speaker":"1-T Rajendra Kumar, PhD",
            "location":"1-Aurora, Colorado",
            "Download": "1-Download"
            },
            {
            "name":"Poster PRESENTATIONS",
            "presentationtitle":"3-Plenary Symposium 2—Hormones of Menopause",
            "description":"2-FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes And Other Factors?",
            "speaker":"2-T Rajendra Kumar, PhD",
            "location":"2-Aurora, Colorado",
            "Download": "2-Download"
            },
            {
            "name":"Poster PRESENTATIONS",
            "presentationtitle":"3-Plenary Symposium 2—Hormones of Menopause",
            "description":"3-FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes And Other Factors?",
            "speaker":"3-T Rajendra Kumar, PhD",
            "location":"3-Aurora, Colorado",
            "Download": "3-Download"
            },
            {
            "name":"Poster PRESENTATIONS",
            "presentationtitle":"4-Plenary Symposium 2—Hormones of Menopause",
            "description":"4-FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes And Other Factors?",
            "speaker":"4-T Rajendra Kumar, PhD",
            "location":"4-Aurora, Colorado",
            "Download": "4-Download"
            },
            {
            "name":"Poster PRESENTATIONS",
            "presentationtitle":"4-Plenary Symposium 2—Hormones of Menopause",
            "description":"4-FSH: Passive Reflection of the Ovary or Active Driver of Menopause Processes And Other Factors?",
            "speaker":"5-T Rajendra Kumar, PhD",
            "location":"5-Aurora, Colorado",
            "Download": "5-Download"
            }
        ]
        }
         }

         */

         /*
         
        function AbstractsdataFunction() {
            
    var Results = "<div class='row mb-5'><div class='col-md-7 col-lg-8 col-xl-9 '><p class='wk-size-4 mt-8' id='ResultsCount'>110 Results</p></div><div class='col-md-5 col-lg-4 col-xl-3 '>  <wk-select label='Show All' class='wk-field-select-container'><select class='wk-field-select selectW-85' id='select_filter'><option value='All'>All</option></select> </wk-select></div></div></div></div><div class='col-md-12 mb-5 p-0 smp-0 mx-auto'><div id='ResultData'>"
    document.getElementById("ResultsSection").innerHTML = Results;
    var Results_Count = 0;
    for (var r = 0, len=Object.keys(NamsResultsObj).length; r < len; r++) {
        var NamsResultsObjlengthval = (Object.keys(NamsResultsObj)[r])
        Results_Count += NamsResultsObj[NamsResultsObjlengthval].categorydata.length
    }
    document.getElementById("ResultsCount").innerHTML = Results_Count + "  Results";
    
    
    let dropdown = document.getElementById('select_filter');
    dropdown.length = 0;
    let defaultOption = document.createElement('option');
    defaultOption.text = 'All';
    defaultOption.value = '';
    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;
    for (var r = 0, len=Object.keys(NamsResultsObj).length; r < len; r++) {
        var NamsResultsObjlengthval = (Object.keys(NamsResultsObj)[r])
         var  option = document.createElement('option');
          option.text = Object.keys(NamsResultsObj)[r];
          option.value = Object.keys(NamsResultsObj)[r];
          dropdown.add(option);
    }
    
    function change_Showselect(selectdata) {
    var hedding = "";
    if(selectdata){
        
        $('.categoryname').hide();
        $('.categoryname.' + selectdata).show();
        
    }else{
        for (var h = 0, len = Object.keys(NamsResultsObj).length; h < len; h++) {
            var NamsResultsObjlengthval = (Object.keys(NamsResultsObj)[h]) 
            var cssclasname = 'categoryname ' + NamsResultsObjlengthval.replace(/\s/g, "")
            hedding +=  "<div class= " + "'" +  cssclasname  + "'" + ">"
            hedding += "<h3 class='wk-col-12 mb-4 categoryhedding'> " + NamsResultsObj[NamsResultsObjlengthval].categoryname + " (" + NamsResultsObj[NamsResultsObjlengthval].categorydata.length + ")" + "</h3>"
            var i;
            var Speaker = "<div class='row'>";
            for (i = 0; i < NamsResultsObj[NamsResultsObjlengthval].categorydata.length; i++) {
                Speaker += "<div class='col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3'><div class='card'><div class='card-content'> <div class='wk-tag-blue'>" + NamsResultsObj[NamsResultsObjlengthval].categorydata[i].name + "</div>" + "<div class='wk-card-subtitle mt-2'>" + NamsResultsObj[NamsResultsObjlengthval].categorydata[i].presentationtitle + "</div>" + "<div class='wk-docs-paragraph-sample wk-margins'><p class='mb-2 mt-2 card-desc'>" + NamsResultsObj[NamsResultsObjlengthval].categorydata[i].description + "</p></div>" + "<h3 class='wk-card-subtitle-name'>" + NamsResultsObj[NamsResultsObjlengthval].categorydata[i].speaker + "</h3>" + "<div class='wk-card-subtitle-italic'>" + NamsResultsObj[NamsResultsObjlengthval].categorydata[i].location + "</div>" + "<div class='wk-text-danger-Download mt-4'>" + "<a href='NAMSPDF.pdf' class='Download-text' download='downloadPDF'>" + NamsResultsObj[NamsResultsObjlengthval].categorydata[i].Download + "</a>" + "</div>" + "</div></article></div></div>";
            }
            Speaker += "</div></div></div>"
            hedding += Speaker 
            document.getElementById("ResultData").innerHTML = hedding;
        }
    }
    
          }
    
    change_Showselect();
    document.getElementById("select_filter").onchange = function() {change_Showselect(this.value)};
    if($('.container-fluid').height() < $(window).height()){
        $('.row.footer-container').addClass('footerfixedpos')
    }else{
        $('.row.footer-container').removeClass('footerfixedpos')
    }
          } 


*/







}


export default AbstractsWebPart;


// WEBPACK FOOTER //
// ./src/nams2020/webparts/Abstracts/index.js